import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PlanUsageOutlineButton from './PlanUsageOutlineButton'
import { PLAN_USAGE } from './planUsageDesignTokens'

/** @param {{ usedFraction: number, usedLabel: string, capLabel: string, percentLabel: string }} props */
export function PlanUsageTokenMeter({ usedFraction, usedLabel, capLabel, percentLabel }) {
  const pct = Math.min(100, Math.max(0, Math.round(usedFraction * 1000) / 10))
  return (
    <Stack spacing={0.875} alignItems="stretch" sx={{ width: '100%', minWidth: 0 }}>
      <Stack direction="row" alignItems="center" sx={{ width: '100%', minWidth: 0, gap: 0 }}>
        <Typography sx={{ flex: '1 1 auto', minWidth: 0, fontSize: '0.875rem', fontWeight: 510, lineHeight: '24px', color: 'text.primary' }}>Tokens Used</Typography>
        <Typography sx={{ flexShrink: 0, fontSize: '1rem', fontWeight: 700, lineHeight: '24px', color: 'text.primary' }}>{percentLabel}</Typography>
      </Stack>
      <Box sx={{ width: '100%', height: 4, borderRadius: '12px', bgcolor: 'background.default', overflow: 'hidden' }}>
        <Box sx={{ width: `${pct}%`, height: '100%', borderRadius: '12px', bgcolor: PLAN_USAGE.progressFill }} />
      </Box>
      <Stack direction="row" justifyContent="flex-start" alignItems="center" sx={{ width: '100%', minWidth: 0 }}>
        <Box sx={{ display: 'flex', flex: '1 1 auto', minWidth: 0, justifyContent: 'flex-start', alignItems: 'center' }}>
          <PlanUsageOutlineButton variant="soft" aria-label={`Token usage ${usedLabel} of ${capLabel}`}>{usedLabel} / {capLabel}</PlanUsageOutlineButton>
        </Box>
        <PlanUsageOutlineButton aria-label="Manage token allowance">manage</PlanUsageOutlineButton>
      </Stack>
    </Stack>
  )
}
